import * as Layout from 'bee-layout'

export default Layout
